export default "__VITE_ASSET__e609af43__"